import {
    TableFilterParams,
} from 'app/types/common.types'
import BatchActionIcon from 'app/shared-components/TableControls/BatchActionIcon'
import {
    useTableActionsContext,
} from 'app/shared-components/TableActionsContext'

type Props = {
    getFilterParams: () => TableFilterParams
    isMenuItem?: boolean
}

const BatchUpdateButton = ({
    getFilterParams,
    isMenuItem = false,
}: Readonly<Props>) => {
    const {
        setBatchActionData,
    } = useTableActionsContext()

    const handleClick = () => {
        setBatchActionData(getFilterParams())
    }

    return (
        <BatchActionIcon
            isMenuItem={isMenuItem}
            onClick={handleClick}
        />
    )
}

export default BatchUpdateButton
